import _slicedToArray from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["anchor"],
  _excluded2 = ["anchor"];
import { keys } from '../../util/helpers';
import { colorToInt, intToHex, colorToHex } from '../../util/colorUtils';
import * as sRGB from '../../util/color/transformSRGB';
import * as LAB from '../../util/color/transformCIELAB';
export function parse(theme) {
  var isItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var variations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var anchor = theme.anchor,
    variant = _objectWithoutProperties(theme, _excluded);
  var colors = Object.keys(variant);
  var parsedTheme = {};
  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];
    if (value == null) continue;
    if (!variations) {
      parsedTheme[name] = {
        base: intToHex(colorToInt(value))
      };
    } else if (isItem) {
      /* istanbul ignore else */
      if (name === 'base' || name.startsWith('lighten') || name.startsWith('darken')) {
        parsedTheme[name] = colorToHex(value);
      }
    } else if (typeof value === 'object') {
      parsedTheme[name] = parse(value, true, variations);
    } else {
      parsedTheme[name] = genVariations(name, colorToInt(value));
    }
  }
  if (!isItem) {
    parsedTheme.anchor = anchor || parsedTheme.base || parsedTheme.primary.base;
  }
  return parsedTheme;
}
/**
 * Generate the CSS for a base color (.primary)
 */

var genBaseColor = function genBaseColor(name, value) {
  return "\n.v-application .".concat(name, " {\n  background-color: ").concat(value, " !important;\n  border-color: ").concat(value, " !important;\n}\n.v-application .").concat(name, "--text {\n  color: ").concat(value, " !important;\n  caret-color: ").concat(value, " !important;\n}");
};
/**
 * Generate the CSS for a variant color (.primary.darken-2)
 */

var genVariantColor = function genVariantColor(name, variant, value) {
  var _variant$split = variant.split(/(\d)/, 2),
    _variant$split2 = _slicedToArray(_variant$split, 2),
    type = _variant$split2[0],
    n = _variant$split2[1];
  return "\n.v-application .".concat(name, ".").concat(type, "-").concat(n, " {\n  background-color: ").concat(value, " !important;\n  border-color: ").concat(value, " !important;\n}\n.v-application .").concat(name, "--text.text--").concat(type, "-").concat(n, " {\n  color: ").concat(value, " !important;\n  caret-color: ").concat(value, " !important;\n}");
};
var genColorVariableName = function genColorVariableName(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return "--v-".concat(name, "-").concat(variant);
};
var genColorVariable = function genColorVariable(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return "var(".concat(genColorVariableName(name, variant), ")");
};
export function genStyles(theme) {
  var cssVar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var anchor = theme.anchor,
    variant = _objectWithoutProperties(theme, _excluded2);
  var colors = Object.keys(variant);
  if (!colors.length) return '';
  var variablesCss = '';
  var css = '';
  var aColor = cssVar ? genColorVariable('anchor') : anchor;
  css += ".v-application a { color: ".concat(aColor, "; }");
  cssVar && (variablesCss += "  ".concat(genColorVariableName('anchor'), ": ").concat(anchor, ";\n"));
  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];
    css += genBaseColor(name, cssVar ? genColorVariable(name) : value.base);
    cssVar && (variablesCss += "  ".concat(genColorVariableName(name), ": ").concat(value.base, ";\n"));
    var variants = keys(value);
    for (var _i = 0; _i < variants.length; ++_i) {
      var _variant = variants[_i];
      var variantValue = value[_variant];
      if (_variant === 'base') continue;
      css += genVariantColor(name, _variant, cssVar ? genColorVariable(name, _variant) : variantValue);
      cssVar && (variablesCss += "  ".concat(genColorVariableName(name, _variant), ": ").concat(variantValue, ";\n"));
    }
  }
  if (cssVar) {
    variablesCss = ":root {\n".concat(variablesCss, "}\n\n");
  }
  return variablesCss + css;
}
export function genVariations(name, value) {
  var values = {
    base: intToHex(value)
  };
  for (var i = 5; i > 0; --i) {
    values["lighten".concat(i)] = intToHex(lighten(value, i));
  }
  for (var _i2 = 1; _i2 <= 4; ++_i2) {
    values["darken".concat(_i2)] = intToHex(darken(value, _i2));
  }
  return values;
}
export function lighten(value, amount) {
  var lab = LAB.fromXYZ(sRGB.toXYZ(value));
  lab[0] = lab[0] + amount * 10;
  return sRGB.fromXYZ(LAB.toXYZ(lab));
}
export function darken(value, amount) {
  var lab = LAB.fromXYZ(sRGB.toXYZ(value));
  lab[0] = lab[0] - amount * 10;
  return sRGB.fromXYZ(LAB.toXYZ(lab));
}